/**
 * Форматирование и валидация номера телефона.
 * Приводит к формату +7XXXXXXXXXX для российских номеров.
 */

/** Извлечь только цифры из строки */
export function extractDigits(value) {
  return value.replace(/\D/g, '');
}

/** Очистить ввод — оставить только цифры и + в начале */
export function cleanPhoneInput(value) {
  // Разрешаем только цифры
  return value.replace(/[^\d]/g, '');
}

/** Форматировать номер для отображения: +7 (XXX) XXX-XX-XX */
export function formatPhoneDisplay(value) {
  const digits = extractDigits(value);
  if (digits.length === 0) return '';

  let body = digits;
  if (body.startsWith('8')) {
    body = '7' + body.slice(1);
  }
  if (!body.startsWith('7')) {
    body = '7' + body;
  }
  body = body.slice(0, 11);

  const d = body.slice(1);
  let result = '+7';
  if (d.length > 0) result += ' (' + d.slice(0, 3);
  if (d.length >= 3) result += ') ';
  if (d.length > 3) result += d.slice(3, 6);
  if (d.length >= 6) result += '-';
  if (d.length > 6) result += d.slice(6, 8);
  if (d.length >= 8) result += '-';
  if (d.length > 8) result += d.slice(8, 10);

  return result;
}

/** Нормализовать номер для отправки на сервер: +79991234567 */
export function normalizePhone(value) {
  const digits = extractDigits(value);
  if (digits.length === 0) return '';
  let d = digits;
  if (d.startsWith('8') && d.length === 11) {
    d = '7' + d.slice(1);
  }
  // Без кода страны: 9991234567 → +79991234567
  if (d.startsWith('9') && d.length === 10) {
    d = '7' + d;
  }
  if (d.startsWith('7') && d.length === 11) {
    return '+' + d;
  }
  return value;
}

/** Проверить, полный ли номер (11 цифр) */
export function isPhoneComplete(value) {
  return extractDigits(value).length >= 11;
}
